import { v4 as uuid } from 'uuid';

let visitorUuid: string | null = null;

export default (): string => {
  if (visitorUuid) {
    return visitorUuid;
  }

  try {
    visitorUuid = localStorage.getItem('visitorUuid');
  } catch (e) {
    // because sometimes `SecurityError: The operation is insecure.` happens
  }

  if (typeof visitorUuid !== 'string' || visitorUuid.length !== 36) {
    visitorUuid = uuid();
    try {
      localStorage.setItem('visitorUuid', visitorUuid);
    } catch (e) {
      // because sometimes `SecurityError: The operation is insecure.` happens
    }
  }

  return visitorUuid;
};
